<template>
  <!-- elevate-on-scroll -->
  <v-toolbar flat :color="themeColor">
    <v-img
      id="survey_logo"
     :max-width="250" :max-height="50" :src="headerLogo" contain></v-img>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: "primary",
    },
    headerLogo: {
      type: String,
      // default: "https://www.redsoft.co.kr/images/main_images/header/header-logo.svg"
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #survey_logo > .v-image__image--contain {
  background-position: left center !important;
}
</style>
